import { createSlice } from '@reduxjs/toolkit';
import { enums as enumsInvestigation } from '../../components/Report/All/Investigation2/Main/useConstants';

export const jaguarSlice = createSlice({
  name: 'jaguar',
  initialState: {
    denuncia: {
      id: "1234dasd"
    },
    reports: [],
    filtredReports: [],
    filterApplied: false,
    fromUrl: null,
    currentReport: {
      reportDetail: null,
      users: { raw: [], formatted: [] },
      me: { raw: {}, formatted: {} },
      relativeFields: {},
      investigation: {
        id: null,
        name: null,
        involvedsInfo: {  raw: [], formatted: [] },
        involvedsAccompliceInfo: { raw: [], formatted: [] },
        involvedsOffenderInfo: { raw: [], formatted: [] },
        involvedsVictimInfo: { raw: [], formatted: [] },
        involvedsWitnessInfo: { raw: [], formatted: [] },
        humanResourcesInfo: { raw: [], formatted: [], approved: [], approvedFormatted: [] },
        accessResourcesInfo: { raw: [], formatted: [], approved: [], approvedFormatted: [] },
        financialResourcesInfo: { raw: [], formatted: [], approved: [], approvedFormatted: [] },
        materialResourcesInfo: { raw: [], formatted: [], approved: [], approvedFormatted: [] },
      },
    },
  },
  reducers: {
    setDenuncia: (state, { payload }) => {
      state.denuncia = payload;
    },
    setReports: (state, { payload }) => {
      state.reports = payload;
    },
    setFiltredReports: (state, { payload }) => {
      state.filtredReports = payload;
    },
    setFilterApplied: (state, { payload }) => {
      state.filterApplied = payload;
    },
    setFromUrl: (state, { payload }) => {
      state.fromUrl = payload;
    },
    setCurrentReport: (state, { payload }) => {
      state.currentReport = {
        ...state.currentReport,
        ...payload,
      };
    },
    setCurrentReportInvestigation: (state, { payload }) => {
      state.currentReport.investigation = {
        ...state.currentReport.investigation,
        ...payload,
      };
    },
  }
});

export const {
  setDenuncia,
  setReports,
  setFiltredReports,
  setFilterApplied,
  setFromUrl,
  setCurrentReport,
  setCurrentReportInvestigation,
} = jaguarSlice.actions;